import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', href: '/' },
    { label: '分类浏览', href: '/category/all' },
    { label: '热门排行', href: '/#ranking' },
    { label: '新作速递', href: '/#new-releases' },
    { label: '关于我们', href: '/about' },
  ],
  categories: [
    { label: '校园青春', href: '/category/campus' },
    { label: '职场OL', href: '/category/office' },
    { label: '奇幻异世界', href: '/category/fantasy' },
    { label: '纯爱言情', href: '/category/romance' },
    { label: '热血战斗', href: '/category/action' },
    { label: '日常治愈', href: '/category/slice-of-life' },
  ],
  about: [
    { label: '品牌介绍', href: '/about' },
    { label: '联系方式', href: '/about#contact' },
    { label: '用户口碑', href: '/about#reputation' },
    { label: '加入我们', href: '/about#join' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 text-xl font-bold font-heading text-white mb-4 whitespace-nowrap">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm">
                <i className="ri-book-read-line"></i>
              </span>
              黄漫天堂
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              黄漫天堂是专为漫画爱好者打造的一站式内容导航平台，汇聚海量黄漫资源分类推荐、热门作品排行与创作者专区，畅享极致漫画体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-all duration-200" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 font-heading">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 font-heading">分类浏览</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 font-heading">关于我们</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-5">
              <p className="text-sm text-foreground-400">联系邮箱</p>
              <a href="mailto:contact@huangman.tt" className="text-sm text-primary-400 hover:text-primary-300 transition-colors duration-200">
                contact@huangman.tt
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黄漫天堂 huangman.tt - 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-300 transition-colors duration-200">隐私政策</a>
            <a href="#" className="hover:text-foreground-300 transition-colors duration-200">服务条款</a>
            <a href="#" className="hover:text-foreground-300 transition-colors duration-200">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}